import { render, staticRenderFns } from "./NotFoundScanCount.vue?vue&type=template&id=40154629&scoped=true&"
import script from "./NotFoundScanCount.vue?vue&type=script&lang=js&"
export * from "./NotFoundScanCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40154629",
  null
  
)

export default component.exports